import {
    CREATE_STITCHING_DC_DETAILS_FAILURE,
    CREATE_STITCHING_DC_DETAILS_REQUEST,
    CREATE_STITCHING_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_STITCHING_DC_DETAILS,
    DELETE_STITCHING_DC_DETAILS_FAILURE,
    DELETE_STITCHING_DC_DETAILS_REQUEST,
    DELETE_STITCHING_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE,
    FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST,
    FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS,
    FETCH_STITCHING_DC_DETAILS_FAILURE,
    FETCH_STITCHING_DC_DETAILS_REQUEST,
    FETCH_STITCHING_DC_DETAILS_SUCCESS,
    STITCHING_DC_DETAILS_USERFORM_RESET,
    UPDATE_STITCHING_DC_DETAILS_FAILURE,
    UPDATE_STITCHING_DC_DETAILS_REQUEST,
    UPDATE_STITCHING_DC_DETAILS_SUCCESS,
    FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST,
    FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_STITCHING_DC_PREVIOUS_LIST_REQUEST,
    FETCH_STITCHING_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_STITCHING_DC_PREVIOUS_LIST_FAILURE,
    CREATE_USER_FORM_STITCHING_DC_EDIT_QTY,
    RESET_STITCHING_DC_EDIT_QTY_V2,
    RESET_STITCHING_DC_SECOND_GRIG_EDIT_QTY_V2,
    CREATE_USER_FORM_STITCHING_DC_SECOND_GRID_EDIT_QTY,
    FETCH_STITCHING_DC_DETAILS_FIRST_GRID_REQUEST,
    FETCH_STITCHING_DC_DETAILS_FIRST_GRID_SUCCESS,
    FETCH_STITCHING_DC_DETAILS_FIRST_GRID_FAILURE,
    FETCH_STITCHING_DC_DETAILS_SECOND_GRID_FAILURE,
    FETCH_STITCHING_DC_DETAILS_SECOND_GRID_SUCCESS,
    FETCH_STITCHING_DC_DETAILS_SECOND_GRID_REQUEST,
    CREATE_STITCHING_DC_DETAILS2_REQUEST,
    CREATE_STITCHING_DC_DETAILS2_SUCCESS,
    CREATE_STITCHING_DC_DETAILS2_FAILURE,
    FETCH_STITCHING_DC_DETAILS_DN_BY_ID_REQUEST,
    FETCH_STITCHING_DC_DETAILS_DN_BY_ID_SUCCESS,
    FETCH_STITCHING_DC_DETAILS_DN_BY_ID_FAILURE,
    CREATE_USER_FORM_STITCHING_DC_GENERATE_QTY,
    CREATE_BARCODE_TEMPLATES_REQUEST,
    CREATE_BARCODE_TEMPLATES_FAILURE,
    CREATE_BARCODE_TEMPLATES_SUCCESS,
    CREATE_STITCHING_WITH_ACC_SUCCESS,
    CREATE_STITCHING_WITH_ACC_FAILURE,
    CREATE_STITCHING_WITH_ACC_REQUEST,
    STITCHING_DC_PROGRAM_ID_SUCCESS,
    STITCHING_DC_PROGRAM_ID_REQUEST,
    STITCHING_DC_PROGRAM_ID_FAILURE,
    STITCHING_DC_WITH_ACC_SUCCESS,
    STITCHING_DC_WITH_ACC_FAILURE,
    STITCHING_DC_WITH_ACC_REQUEST,
    CREATE_USER_FORM_STITCHING_DC_WITH_ACC_GENERATE_QTY,
    NAVIGATE_STITCHING_WITH_ACC,
    FETCH_STITCHING_DC_DETAILS_DN_BY_ID_EDIT_QTY,
    STITCHING_DC_WITH_DN_PRINT_FAILURE,
    STITCHING_DC_WITH_DN_PRINT_REQUEST,
    STITCHING_DC_WITH_DN_PRINT_SUCCESS,
    RELOAD_TO_DEFAULT_STATE_DN_PRINT,
    DELETE_STITCHING_ACCESSORIES_REQUEST,
    DELETE_STITCHING_ACCESSORIES_SUCCESS,
    DELETE_STITCHING_ACCESSORIES_FAILURE,
    DELETE_STITCHING_BARCODE_REQUEST,
    DELETE_STITCHING_BARCODE_FAILURE,
    RESET_TO_RERVIOUS_LIST,
    STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_SUCCESS,
    STITCHING_DC_WITH_DN_PRINT_DELETE_FAILURE,
    STITCHING_DC_WITH_DN_PRINT_DELETE_REQUEST,
    GET_TO_SEARCH_LIST,
    STITCHING_DC_WITH_BUNDLE_GET_REQUEST,
    STITCHING_DC_WITH_BUNDLE_GET_FAILURE,
    STITCHING_DC_WITH_BUNDLE_GET_SUCCESS,
    STITCHING_DC_WITH_BUNDLE_POST_SUCCESS,
    STITCHING_DC_WITH_BUNDLE_POST_REQUEST,
    STITCHING_DC_WITH_BUNDLE_POST_FAILURE,
    STITCHING_DC_WITH_BUNDLE_POST_GET_REQUEST,
    STITCHING_DC_WITH_BUNDLE_POST_GET_SUCCESS,
    STITCHING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE,
    PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS,
    STITCHING_WITH_BUNDLE_RESET_DATA,
    UPDATE_STITCHING_BUNDLE_FILTER_INITIAL,
    CREATE_STITCHING_WITH_BARCODE_TOGGLE_PRINT_SUCCESS,
    STITCHING_DC_WITH_FOLDING_FABRIC_GET_SUCCESS,
    STITCHING_DC_WITH_FOLDING_FABRIC_GET_REQUEST,
    STITCHING_DC_WITH_FOLDING_FABRIC_GET_FAILURE,

} from './stitchingDCDetails.actionsType';

export const STITCHING_DC_DETAILS = 'stitchingDCDetails';

let initialState = {
    loading: false,
    stitchingDCDetailsById: [],
    stitchingDCDetails: [],
    previousList: [],
    editStitchingQtyList: [],
    editStitchingSecondGridQtyList: [],
    stitchingDCDetailsDNById: [],
    grnNoByYarnPO: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldFKBagWeight: 0,
        fldFKNoofBags: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldDiscountPercentage: 0,
        fldIsShowAll: 0,
        InwardNO: []
    },
    selectedStitchingDCDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    stitchingDNPrint: [],
    restDefault: false,
    foldingFabric: ''
};

export let stitchingDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_STITCHING_DC_DETAILS_REQUEST:
        case FETCH_STITCHING_DC_DETAILS_FIRST_GRID_REQUEST:
        case FETCH_STITCHING_DC_DETAILS_SECOND_GRID_REQUEST:
        case FETCH_STITCHING_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_STITCHING_DC_DETAILS_BY_ID_REQUEST:
        case FETCH_STITCHING_DC_DETAILS_DN_BY_ID_REQUEST:
        case CREATE_STITCHING_DC_DETAILS_REQUEST:
        case CREATE_STITCHING_DC_DETAILS2_REQUEST:
        case FETCH_SINGLE_STITCHING_DC_DETAILS_REQUEST:
        case UPDATE_STITCHING_DC_DETAILS_REQUEST:
        case DELETE_STITCHING_DC_DETAILS_REQUEST:
        case CREATE_BARCODE_TEMPLATES_REQUEST:
        case CREATE_STITCHING_WITH_ACC_REQUEST:
        case STITCHING_DC_PROGRAM_ID_REQUEST:
        case STITCHING_DC_WITH_ACC_REQUEST:
        case STITCHING_DC_WITH_DN_PRINT_REQUEST:
        case DELETE_STITCHING_ACCESSORIES_REQUEST:
        case DELETE_STITCHING_BARCODE_REQUEST:
        case STITCHING_DC_WITH_DN_PRINT_DELETE_REQUEST:
        case STITCHING_DC_WITH_BUNDLE_GET_REQUEST:
        case STITCHING_DC_WITH_BUNDLE_POST_REQUEST:
        case STITCHING_DC_WITH_BUNDLE_POST_GET_REQUEST:
        case STITCHING_DC_WITH_FOLDING_FABRIC_GET_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STITCHING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCDetails: updatePayload
            };
        case STITCHING_DC_WITH_FOLDING_FABRIC_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                foldingFabric: updatePayload
            }
        case STITCHING_DC_WITH_BUNDLE_POST_GET_SUCCESS:
            return {
                ...state,
                stitchingBundlePrevList: updatePayload.Program
            }

        // case PRINTING_DC_WITH_BUNDLE_POST_GET_SUCCESS:
        //     return {
        //         ...state,
        //         printingBundlePrevList: updatePayload
        //     }

        case STITCHING_DC_WITH_BUNDLE_GET_SUCCESS:
            return {
                ...state,
                stitchingBundleGetList: updatePayload?.Program?.map((x) => ({ ...x, FldIssuedBundleCount: x.FldBundleCount, isActive: false })),
                stitchingBundleGetListFilter: updatePayload?.Program?.map((x) => ({ ...x, FldIssuedBundleCount: x.FldBundleCount, isActive: false, FldBundleCount: x.FldPendingBundleCount, initialBundleCount: x.FldPendingBundleCount }))
            }
        case UPDATE_STITCHING_BUNDLE_FILTER_INITIAL: {
            return {
                ...state,
                stitchingBundleGetListFilter: payload
            }
        }
        case STITCHING_DC_WITH_BUNDLE_UPDATE_SELECTED_BUNDLE:
            return {
                ...state,
                stitchingBundleGetList: payload

            }
        case STITCHING_WITH_BUNDLE_RESET_DATA:
            return {
                ...state,
                stitchingBundleGetList: [],
                stitchingBundleGetListFilter: []
            }
        case CREATE_STITCHING_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingAcc: updatePayload

            }
        case FETCH_STITCHING_DC_DETAILS_FIRST_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                editStitchingQtyList:
                    updatePayload?.Program && updatePayload?.Program.map((x) => ({ ...x, fldRate: x?.FldPrice, fldQuantity: Number(x?.CuttingInwardQty) - Number(x.AlrdDesQty), CuttingInwardQty: x.CuttingInwardQty }))
            };
        case CREATE_USER_FORM_STITCHING_DC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editStitchingQtyList1: payload
            }


        case CREATE_USER_FORM_STITCHING_DC_WITH_ACC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editAccQtyList: payload
                // editAccQtyList: payload?.map((x) => ({ ...x, CurrentIssue: x.availableQty }))
            }
        case RESET_TO_RERVIOUS_LIST:
            return {
                ...state,
                loading: false,
                editAccQtyList: []
            }
        case STITCHING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload.fldFKProgram,
                program: updatePayload

            }
        case FETCH_STITCHING_DC_DETAILS_SECOND_GRID_SUCCESS:

            return {
                ...state,
                loading: false,
                editStitchingSecondGridQtyList:
                    updatePayload?.STDDN && updatePayload?.STDDN.map((x) => ({
                        ...x,
                        // fldQuantity: Number(x?.CuttingInwardQty) - Number(x.AlrdDesQty), CuttingInwardQty: x.CuttingInwardQty , 
                        // fldQuantity: x?.DNQty,
                        // fldQuantity: Math.min(Number(x.CuttingInwardQty), Number(x?.PreQty)),
                        fldQuantity: Math.min(Number(x?.CuttingInwardQty || 0), Number(x?.PreQty || 0)) - (Number(x?.AlrdDesQty) || 0),
                        minQty: Math.min(Number(x.CuttingInwardQty), Number(x?.PreQty))

                        // fldQuantity: Number(x?.CuttingInwardQty) - Number(x.AlrdDesQty),


                    })),
                getSearchedItem:
                    updatePayload?.STDDN && updatePayload?.STDDN.map((x) => ({
                        ...x,

                        // fldQuantity: Number(x?.CuttingInwardQty) - Number(x.AlrdDesQty), CuttingInwardQty: x.CuttingInwardQty

                        // fldQuantity: x?.DNQty,
                        fldQuantity: Math.min(Number(x?.CuttingInwardQty || 0), Number(x?.PreQty || 0)) - (Number(x?.AlrdDesQty) || 0),

                        minQty: Math.min(Number(x.CuttingInwardQty), Number(x?.PreQty))

                        // fldQuantity: Number(x?.CuttingInwardQty) - Number(x.AlrdDesQty),


                    }))







            };
        case GET_TO_SEARCH_LIST:
            return {
                ...state,
                getSearchedItem: payload
            }
        case FETCH_STITCHING_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsById: updatePayload
            };
        case FETCH_STITCHING_DC_DETAILS_DN_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsDNById: updatePayload
            };

        case FETCH_STITCHING_DC_DETAILS_DN_BY_ID_EDIT_QTY:
            return {
                ...state,
                loading: false,
                stitchingDCDetailsDNById: payload
            }

        case RELOAD_TO_DEFAULT_STATE_DN_PRINT:
            return {
                ...state,
                loading: false,
                restDefault: payload
            }
        case CREATE_STITCHING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                editStitchingQtyList: [],
                status: 'Success'
            };
        case CREATE_STITCHING_DC_DETAILS2_SUCCESS:
            return {
                ...state,
                loading: false,
                editStitchingSecondGridQtyList: []
            };
        case FETCH_SINGLE_STITCHING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case UPDATE_STITCHING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedStitchingDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                }
            };

        case DELETE_STITCHING_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                selectedStitchingDCDetails: {}
            };

        case FETCH_STITCHING_DC_DETAILS_FAILURE:
        case FETCH_STITCHING_DC_DETAILS_DN_BY_ID_FAILURE:
        case FETCH_STITCHING_DC_DETAILS_FIRST_GRID_FAILURE:
        case FETCH_STITCHING_DC_DETAILS_SECOND_GRID_FAILURE:
        case FETCH_SINGLE_STITCHING_DC_DETAILS_FAILURE:
        case CREATE_STITCHING_DC_DETAILS_FAILURE:
        case CREATE_STITCHING_DC_DETAILS2_FAILURE:
        case UPDATE_STITCHING_DC_DETAILS_FAILURE:
        case DELETE_STITCHING_DC_DETAILS_FAILURE:
        case CREATE_BARCODE_TEMPLATES_FAILURE:
        case CREATE_STITCHING_WITH_ACC_FAILURE:
        case STITCHING_DC_PROGRAM_ID_FAILURE:
        case STITCHING_DC_WITH_ACC_FAILURE:
        case STITCHING_DC_WITH_DN_PRINT_FAILURE:
        case DELETE_STITCHING_ACCESSORIES_FAILURE:
        case DELETE_STITCHING_BARCODE_FAILURE:
        case STITCHING_DC_WITH_DN_PRINT_DELETE_FAILURE:
        case STITCHING_DC_WITH_BUNDLE_GET_FAILURE:
        case STITCHING_DC_WITH_BUNDLE_POST_FAILURE:
        case STITCHING_DC_WITH_FOLDING_FABRIC_GET_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_STITCHING_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_STITCHING_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editStitchingQtyList1: payload
            };
        case CREATE_USER_FORM_STITCHING_DC_SECOND_GRID_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editStitchingSecondGridQtyList: payload
            };
        case STITCHING_DC_WITH_DN_PRINT_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDNPrint: updatePayload


                // stitchingDNPrint: updatePayload
                // .STDDN

            }
        case STITCHING_DC_WITH_DN_PRINT_CHECK_ENABLE_SUCCESS:
            return {
                ...state,
                loading: false,
                stitchingDNPrintCheck: updatePayload.STDDN

            }
        case CREATE_BARCODE_TEMPLATES_SUCCESS:
            return {
                ...state,
                loading: false,
                barCodeTemplates: updatePayload
            }
        case RESET_STITCHING_DC_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editStitchingQtyList: []
            };
        case RESET_STITCHING_DC_SECOND_GRIG_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editStitchingSecondGridQtyList: []
            };
        case STITCHING_DC_WITH_ACC_SUCCESS:
            return {
                ...state,
                loading: false,
                accessoriesGetList: updatePayload || []

            }
        case STITCHING_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: [],
                    fldIsShowAll: 0,
                },
                selectedStitchingDCDetails: {},
                editStitchingQtyList: [],
                editStitchingQtyList1: []
            };

        default:
            return state;
    }
};
